(ns frontend.view.components.power-search.trigger.view
  (:require
   [clojure.string :as s]
   [common.localization :as loc]
   [frontend.view.components.power-search.event :as event]
   [frontend.view.components.power-search.results.view :as results]
   [frontend.view.components.power-search.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]))

(defn trigger
  []
  (let [on-key-down (fn [e]
                      (when (and (= "k"
                                    (-> e
                                        .-key
                                        (s/lower-case)))
                                 (or (.-metaKey e)
                                     (.-ctrlKey e)))
                        (.preventDefault e)
                        (rf/dispatch [::event/toggle-open])))]
    (r/create-class
     {:display-name           "trigger"
      :component-did-mount    (fn [] (.addEventListener js/document.body "keydown" on-key-down))
      :component-will-unmount (fn []
                                (.removeEventListener js/document.body "keydown" on-key-down))
      :reagent-render
      (fn []
        (let [open? @(rf/subscribe [::sub/open?])]
          [:div
           [button/square-secondary-open
            {:tooltip  [:div
                        (loc/tr :search)]
             :dom-id "universal-search-button"
             :on-click (fn [e]
                         (rf/dispatch [::event/toggle-open]))}
            [:i.fal.fa-search.text-xl]]
           (when open?
             [results/results])]))})))
